import { gql } from '@apollo/client'

const typeDefs = gql`
  extend type Query {
    loggedInUser: User
  }
`

export default typeDefs
